import 'whatwg-fetch'
import {assertResponse} from './modules/assertResponse'
import {ErrorCodes} from '../constants/ErrorCodes'
import {WriterError} from '../error/WriterError'

/**
 * Check a parsed string for DOMParser errors
 *
 * @param {Document} dom
 *
 * @returns {boolean}
 */
const hasParserError = (dom) => {
    return dom.documentElement.nodeName === 'parsererror'
}

/**
 * Validates the article xml, checking to see if the idf element exists
 *
 * @param {Document} dom
 * @returns {boolean}
 */
const validateArticle = (dom) => {
    return dom.querySelector('idf') !== null
}

/**
 * Parses downloaded article data to XML Document,
 * throws on parser or validation error
 *
 * @param {string} sourceXml
 * @throws {WriterError}
 *
 * @returns {Document}
 */
const parseFromString = function(sourceXml) {
    const parser = new DOMParser()

    const dom = parser.parseFromString(sourceXml, 'application/xml')

    if (hasParserError(dom) || validateArticle(dom) === false) {
        throw new WriterError(ErrorCodes.ARTICLE_WRONG_FORMAT, new Error('Error parsing NewsML Document'), {document: sourceXml})
    }

    return dom
}

/**
 * Parse NewsML into newsItem dom structure and idf
 *
 * @param  {object} splitResponse
 * @returns {{sourceXml: string, headers: object, newsItem: Document}}
 */
const parseNewsML = (splitResponse) => {
    const {sourceXml, headers} = splitResponse
    const newsItem = parseFromString(sourceXml)

    return {
        sourceXml,
        headers,
        newsItem
    }
}

/**
 * Load article from url
 *
 * @param  {string} id
 * @return {object}
 */
const loadArticle = (id) => {
    const location = window.location
    let url = `${location.protocol}//${location.host}`

    url += `/api/newsitem/${id}?imType=${encodeURIComponent('x-im/article')}`

    return fetch(url)
        .then(response => assertResponse(response, {
            400: ErrorCodes.ARTICLE_BAD_REQUEST,
            401: ErrorCodes.ARTICLE_UNAUTHORIZED,
            403: ErrorCodes.ARTICLE_FORBIDDEN,
            404: ErrorCodes.ARTICLE_NOT_FOUND
        }))
        .then(async (response) => {
            return {
                sourceXml: await response.text(),
                headers: response.headers
            }
        })
        .then(parseNewsML)
}

export {loadArticle}
